import React from 'react';
// @ts-ignore
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import {
    VerificationService,
    getLogoUrl,
    LogoComponent,
    SuccessResponse,
} from '@sheerid/jslib';
import { redirect } from '../lib/utils/browser';

interface StepSuccessProps {
  verificationService: VerificationService;
}

const StepSuccess = ({ verificationService }: StepSuccessProps) => {
    const hasLogo = !!getLogoUrl(verificationService.programTheme);
    const rewardCode = (verificationService.verificationResponse as SuccessResponse).rewardCode || '${rewardCode}'; // eslint-disable-line no-template-curly-in-string
    const noCodeType = verificationService.programTheme.config.offerType === 'noCode';
    const urlParams = new URLSearchParams(window.location.search);
    const svid = urlParams.get('svid') || '';
    const llpid = urlParams.get('llpid') || '';
    const lppid = urlParams.get('lppid') || '';
    const constructRedirectUrl = () => {
        const redirectUrlBase = new URL(`https://www.linkedin.com/premium/redeem/gift?_ed=${rewardCode}`);
        if (svid) { redirectUrlBase.searchParams.append('svid', svid); }
        if (llpid) { redirectUrlBase.searchParams.append('llpid', llpid); }
        if (lppid) { redirectUrlBase.searchParams.append('lppid', llpid); }
        return redirectUrlBase.href;
    };
    const redirectDestination = constructRedirectUrl();
    return (
        <div id="sid-step-success" className="sid-l-container">
            <div className="sid-header sid-l-horz-center sid-l-space-top-md">
                <div className="sid-l-horz-center">
                    {hasLogo ? (
                        <LogoComponent verificationService={verificationService} />
                    ) : (
                        <img
                            className="sid-l-lead-image"
                            alt=""
                            src="https://s3.amazonaws.com/com.sheerid.resources/common/images/2018/icons/circle-check.svg"
                        />
                    )}
                </div>
                <div
                    className="sid-header__title sid-l-horz-center sid-l-space-top-md"
                    role="alert"
                    aria-live="polite"
                >
                    <FormattedHTMLMessage
                        id="step.success.title"
                        defaultMessage="Success! You've been verified."
                    />
                </div>
                <div className="sid-header__subtitle sid-l-horz-center sid-l-two-thirds-width">
                    <FormattedHTMLMessage
                        id="step.success.subtitle"
                        defaultMessage={`Here is your personal coupon code.
                        It is unique to you and can only be used once.`}
                    />
                </div>
            </div>

            <div className="sid-submit sid-l-space-top-md">
                <button
                    type="button"
                    onClick={() => redirect(redirectDestination)}
                    className="sid-btn sid-btn--dark"
                >
                    <FormattedHTMLMessage
                        id="step.success.redirectButtonText"
                        defaultMessage="Use code now"
                    />
                </button>
            </div>


            <div
                className={`sid-footer sid-l-horz-center ${
                    noCodeType ? 'sid-l-space-top-md' : 'sid-l-space-top-lg'
                }`}
            >
                <FormattedHTMLMessage
                    id="step.success.emailNotification"
                    defaultMessage={`
                    We have emailed you a copy so you can use your code now or later. Look for the email from verify@sheerid.com
                `}
                />
            </div>

            <div className="sid-footer sid-l-horz-center sid-l-space-top-lg sid-h-small-text">
                <FormattedMessage id="companyName" defaultMessage="{Company}">
                    {(companyName:string) => (
                        <FormattedHTMLMessage
                            id="step.success.verificationOnly"
                            defaultMessage={`
                                SheerID handles verification only.
                                Now that you've been approved, please direct all questions about the
                                promotion terms and/or code use to {companyName} customer service.
                            `}
                            values={{ companyName }}
                        />
                    )}
                </FormattedMessage>
            </div>
        </div>
    );
};

export const StepSuccessComponent = StepSuccess;
